import type { ComponentPropsWithoutRef, ElementType } from "react"

import cx from "classnames"

import type {
  CardBgColorsType,
  CardAsType,
  ContentDirectionType,
  CardPaddingType,
  CardBorderType,
  CardContentAlignType,
  CardJustifyContentType,
  CardGapType,
  CardTextAlignType,
} from "./types"

import styles from "./index.module.css"
import {
  CARD_BG_COLORS,
  CARD_CONTENT_DIRECTION,
  CARD_PADDING,
  CARD_BORDER,
  CARD_CONTENT_ALIGN,
  CARD_JUSTIFY_CONTENT,
  CARD_GAP,
  CARD_TEXT_ALIGN,
} from "./types"

export type CardProps<T extends CardAsType> = {
  as?: T
  bgColor?: CardBgColorsType
  direction?: ContentDirectionType
  padding?: CardPaddingType
  border?: CardBorderType
  contentAlign?: CardContentAlignType
  justifyContent?: CardJustifyContentType
  gap?: CardGapType
  textAlign?: CardTextAlignType
} & ComponentPropsWithoutRef<T>

export const Card = <T extends CardAsType = "div">({
  as,
  bgColor = "surface",
  direction = "column",
  padding = "m",
  contentAlign = "stretch",
  justifyContent = "start",
  border,
  gap = "m",
  textAlign = "left",
  children,
  ...htmlProps
}: CardProps<T>): React.JSX.Element => {
  const Component = (as || "div") as ElementType

  const cardClassName = cx(
    styles.card,
    styles[CARD_BG_COLORS[bgColor]],
    styles[CARD_CONTENT_DIRECTION[direction]],
    styles[CARD_PADDING[padding]],
    styles[CARD_CONTENT_ALIGN[contentAlign]],
    styles[CARD_JUSTIFY_CONTENT[justifyContent]],
    styles[CARD_GAP[gap]],
    styles[CARD_TEXT_ALIGN[textAlign]],
    border && styles[CARD_BORDER[border]],
  )

  return (
    <Component className={cardClassName} {...htmlProps}>
      {children}
    </Component>
  )
}
